import request from '@/utils/request';

// 系统首页数据
export function get_homepageApi(data) {
  return request({
    url: '/admin/get_homepage',
    method: 'get',
    params: data,
  });
}

// 更多界面   界面数据
export function system_homepageApi(data) {
  return request({
    url: '/admin/system_homepage',
    method: 'get',
    params: data,
  });
}

// 新增上传文件
export function addFileApi(data) {
  return request({
    url: '/admin/system_homepage',
    method: 'post',
    data,
  });
}

// 修改上传文件
export function fixFileApi(data) {
  return request({
    url: '/admin/system_homepage/' + data.id,
    method: 'put',
    data,
  });
}

// 删除上传文件
export function deleteFileApi(data) {
  return request({
    url: '/admin/system_homepage/' + data.id,
    method: 'delete',
    data,
  });
}

// 文件首页 设定 设置
export function setTopApi(data) {
  return request({
    url: '/admin/homepage_set_top',
    method: 'put',
    data,
  });
}

// 获取上传文件类型
export function fileTypeApi(data) {
  return request({
    url: '/admin/get_homepage_select',
    method: 'get',
    params: data,
  });
}

// 首页通知（新）
export function getHomeBulletinBoard(data) {
  return request({
    url: '/admin/get_home_bulletin_board',
    method: 'get',
    params: data,
  });
}

// 首页通知-更多（新）
export function bulletinBoard(data) {
  return request({
    url: '/admin/bulletin_board',
    method: 'get',
    params: data,
  });
}

// 获取通知下拉框
export function getBulletinBoardSelect(data) {
  return request({
    url: '/admin/get_bulletin_board_select',
    method: 'get',
    params: data,
  });
}

// 添加通知
export function bulletinBoardPost(data) {
  return request({
    url: '/admin/bulletin_board',
    method: 'post',
    data,
  });
}

// 查看通知
export function bulletinBoardGet(id) {
  return request({
    url: `/admin/bulletin_board/${id}`,
    method: 'get',
    params: {},
  });
}

// 修改通知
export function bulletinBoardPut(data) {
  return request({
    url: `/admin/bulletin_board/${data.id}`,
    method: 'put',
    data,
  });
}

// 删除通知
export function bulletinBoardDel(data) {
  return request({
    url: `/admin/bulletin_board/${data.id}`,
    method: 'delete',
    data,
  });
}

// 置顶通知
export function topBulletinBoard(data) {
  return request({
    url: '/admin/top_bulletin_board',
    method: 'post',
    data,
  });
}

// 修改通知
export function readBulletinBoard(id) {
  return request({
    url: `/admin/read_bulletin_board/${id}`,
    method: 'put',
    data: {},
  });
}

// 获取带有vip分组的用户数据
export function getSuggestionAdminSelect() {
  return request({
    url: `/admin/get_suggestion_admin_select`,
    method: 'get',
    params: {},
  });
}
